// extracted by mini-css-extract-plugin
export default {"main-header":"main-header--6e1ee6","mainHeader":"main-header--6e1ee6"};